export default "__VITE_ASSET__D2EC1U4___"